import React, { useMemo } from 'react';
import { FormControl, FormErrorMessage } from '@podiumhq/design-system';
import Input from './Input';
import useOTP from './useOTP';

const OtpInput = ({
  OTPLength = 4,
  disabled = false,
  autoFocus = true,
  value = '',
  onChange = () => {},
  otpType = 'number',
  error = null,
}) => {
  const {
    activeInput,
    getOtpValue,
    handleOnChange,
    handleOnKeyDown,
    handelOnInput,
    handleOnPaste,
    onInputFocus,
  } = useOTP({
    autoFocus,
    value,
    otpType,
    onChange,
    OTPLength,
  });

  const renderInputs = useMemo(() => {
    const otp = getOtpValue();
    const inputs = [];

    for (let index = 0; index < OTPLength; index++) {
      const isLast = index === OTPLength - 1;
      inputs.push(
        <Input
          key={`phone-verification-pin-${index}`}
          data-testid="input"
          disabled={disabled}
          focus={activeInput === index}
          id={`phone-verification-pin-${index}`}
          index={index}
          isLast={isLast}
          onChange={handleOnChange}
          onInput={handelOnInput}
          onInputFocus={onInputFocus}
          onKeyDown={handleOnKeyDown}
          onPaste={handleOnPaste}
          otpType={otpType}
          value={otp[index]}
        />
      );
    }

    return inputs;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getOtpValue,
    OTPLength,
    handleOnChange,
    handleOnKeyDown,
    handelOnInput,
    handleOnPaste,
    onInputFocus,
    disabled,
    autoFocus,
  ]);

  return (
    <FormControl isInvalid={error}>
      {renderInputs}
      {error && (
        <FormErrorMessage sx={{ marginTop: '8px' }}>{error}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default OtpInput;
